import { connect } from 'react-redux'

import InvitedCreators from './units'

const mapStateToProps = (state) => {
  const [...invitedCreators] = state.ProjectDetail.invitedCreators.map(
    detail => ({
      ...detail.profile,
      isWithdrawn: detail.isWithdrawn,
      status: detail.status,
      detailId: detail.id,
    }),
  )

  const pitchRows = state.ProjectPitch.data.pitches.map(pitch => ({
    name: pitch.profile.name,
    status: pitch.status,
  }))


  const pitch = state.ProjectPitch.data.pitches

  return {
    pitch,
    invitedCreators,
    pitchRows,

    projectId: state.ProjectDetail.data.id,
  }
}


export default connect(
mapStateToProps,
)(InvitedCreators)
